// Core
import React from "react";

// Styles
import "./style.scss";

// Custom component
import NumberStepper from "Components/NumberStepper";

const ApprovalSubModule = ({
  subModule,
  index,
  totalSteps,
  currentSubCategoryIndex,
  onclick,
  displayNumber,
}) => {
  return (
    <div className="subModule">
      <div className="stepper">
        {/* Use Stepper Component */}
        <NumberStepper
          index={index}
          status={subModule?.isCompleted}
          totalSteps={totalSteps}
          currentSubCategoryIndex={currentSubCategoryIndex}
          hideNumber={
            subModule?.subCategory_name === "Feedback" ||
            subModule?.subCategory_name === "Additional insights"
          }
          displayNumber={displayNumber}
        />

        {/* Step Details */}
        <div className="step-details">
          <div className="subModTitle" onClick={onclick}>{subModule.subCategory_name}</div>
          <div className={`subModStatus my-3`}></div>
        </div>
      </div>
    </div>
  );
};

export default ApprovalSubModule;
